import React from 'react';
import { motion } from 'framer-motion';
import { Star, MapPin } from 'lucide-react';
import { Button } from './ui/Button';
const companions = [{
  id: 1,
  name: 'Isabella Chen',
  tagline: '优雅知性，精通双语',
  rating: 5.0,
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  available: true,
  location: 'Orchard'
}, {
  id: 2,
  name: 'Sophie Zhang',
  tagline: '活泼开朗，高尔夫达人',
  rating: 4.9,
  image: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  available: true,
  location: 'Marina Bay'
}, {
  id: 3,
  name: 'Elena Wu',
  tagline: '艺术气质，钢琴演奏',
  rating: 5.0,
  image: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  available: false,
  location: 'Sentosa'
}, {
  id: 4,
  name: 'Victoria Li',
  tagline: '商务精英，谈吐不凡',
  rating: 4.8,
  image: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  available: true,
  location: 'CBD'
}, {
  id: 5,
  name: 'Jasmine Tan',
  tagline: '温柔体贴，倾听者',
  rating: 4.9,
  image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  available: true,
  location: 'Bugis'
}, {
  id: 6,
  name: 'Ruby Lin',
  tagline: '时尚模特，派对焦点',
  rating: 5.0,
  image: 'https://images.unsplash.com/photo-1524250502761-1ac6f2e30d43?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  available: true,
  location: 'Clarke Quay'
}];
export function FeaturedCompanions() {
  return <section className="py-24 bg-dark-surface" data-id="element-89">
      <div className="container mx-auto px-4" data-id="element-90">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-91">
          <div data-id="element-92">
            <motion.h2 initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="font-serif text-3xl md:text-5xl text-white mb-2" data-id="element-93">
              精选伴游
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-gold-500 uppercase tracking-widest text-sm" data-id="element-94">
              Featured Companions
            </motion.p>
          </div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="hidden md:block" data-id="element-95">
            <Button variant="outline" data-id="element-96">查看全部</Button>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-97">
          {companions.map((companion, index) => <motion.div key={companion.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className="group relative h-[450px] rounded-lg overflow-hidden cursor-pointer" data-id="element-98">
              {/* Image */}
              <img src={companion.image} alt={companion.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-99" />

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity" data-id="element-100" />

              {/* Border Glow */}
              <div className="absolute inset-0 border border-transparent group-hover:border-gold-500/50 transition-colors duration-300 rounded-lg pointer-events-none" data-id="element-101" />

              {/* Status Badge */}
              <div className="absolute top-4 right-4" data-id="element-102">
                <span className={`px-3 py-1 text-xs font-medium rounded-full backdrop-blur-md ${companion.available ? 'bg-green-500/20 text-green-400 border border-green-500/30' : 'bg-red-500/20 text-red-400 border border-red-500/30'}`} data-id="element-103">
                  {companion.available ? 'Available' : 'Booked'}
                </span>
              </div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 w-full p-6 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300" data-id="element-104">
                <div className="flex justify-between items-start mb-2" data-id="element-105">
                  <h3 className="text-2xl font-serif text-white" data-id="element-106">
                    {companion.name}
                  </h3>
                  <div className="flex items-center text-gold-500" data-id="element-107">
                    <Star className="w-4 h-4 fill-current" data-id="element-108" />
                    <span className="ml-1 text-sm font-medium" data-id="element-109">
                      {companion.rating}
                    </span>
                  </div>
                </div>

                <p className="text-gray-300 text-sm mb-4" data-id="element-110">
                  {companion.tagline}
                </p>

                <div className="flex items-center text-gray-400 text-xs mb-6" data-id="element-111">
                  <MapPin className="w-3 h-3 mr-1" data-id="element-112" />
                  {companion.location}
                </div>

                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform translate-y-4 group-hover:translate-y-0" data-id="element-113">
                  <Button size="sm" className="w-full bg-white/10 hover:bg-gold-500 hover:text-black text-white border-0 backdrop-blur-sm" data-id="element-114">
                    预约咨询
                  </Button>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center md:hidden" data-id="element-115">
          <Button variant="outline" className="w-full" data-id="element-116">
            查看全部
          </Button>
        </div>
      </div>
    </section>;
}